import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/app/core/login/authentication/authentication.service';

@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    /**
     *
     * @summary Devulve true si el usuario tiene sesión activa.
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {boolean}
     * @memberof AuthGuard
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        console.log("AuthGuard: Current User", currentUser);
        
        if (currentUser && (currentUser.tokenTrafico && (currentUser.loginTaxis || currentUser.codempleado))) {
            return true;
        }        
        // si el usuario no esta logado se le devolverá a login
        this.router.navigate(['/login']);
        return false;
    }
}